export default "__VITE_ASSET__Dvk2X7M3__"